import {ReactElement} from "react";
import {ISocialProvider} from "@/components/login/SocialLoginButtons";
import useOverwolfInterop from "@/hooks/useOverwolfInterop";

interface Props {
    socialProvider: ISocialProvider;
    onBack: () => void;
}

function SocialProviderProgress(props: Props): ReactElement {
    const { isOnOverwolf } = useOverwolfInterop();

    if (!props.socialProvider) {
        return (
            <div>
                <p>
                    Please login in the new window.
                </p>
            </div>
        );
    }

    return (
        <div>
            <p>
                Please login to {props.socialProvider.name} in the new window.
            </p>
            {/*
              * The provider's page can sit blank for a long time before its own
              * app renders — Discord's consent screen is the worst offender and
              * shows nothing but an empty purple window meanwhile. Users read
              * that as broken, close it or click Connect again, and a second
              * OAuth code goes out; the first code is then spent, so the
              * callback fails with `Invalid "code" in request` on a link that
              * was actually working. Saying it up front is the cheapest fix —
              * measured 15 login starts against only 10 callbacks over three
              * days, with one user needing four attempts across 17 minutes.
              */}
            <p>
                It can take up to 30 seconds to load, and may look blank while it
                does. Please keep the window open.
            </p>
            {!isOnOverwolf &&
                <p>
                    If the new window does not show up, you can{" "}
                    <a href={props.socialProvider.href}>click here</a>{" "}
                    to login in the current tab.
                </p>
            }
            <p>
                Or {" "}
                <button
                    className="reset-link"
                    onClick={props.onBack}
                >
                go back
                </button>{" "}
                to select another login method.
            </p>
        </div>
    );
}

export default SocialProviderProgress;